import {getData, postData} from './redux_data';
import {
    GET_TIPO_FICHA_SUB,
    MODIFY_TIPO_FICHA_SUB,
    ADD_TIPO_FICHA_SUB,
    DELETE_TIPO_FICHA_SUB,
    UPDATE_TIPO_FICHA_SUB,
} from '../constants/action_types';

export function getTipoFichaSubList() {
    return getData('VTipoFichaSubs', GET_TIPO_FICHA_SUB);
}

export function modifyTipoFichaSub(tipoFichaSub) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_TIPO_FICHA_SUB, payload: tipoFichaSub });
    }
}

export function addTipoFichaSub(tipoFichaSub) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_TIPO_FICHA_SUB, payload: tipoFichaSub });
    }
}

export function removeTipoFichaSub(tipoFichaSub) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_TIPO_FICHA_SUB, payload: tipoFichaSub });
    }
}

export function updateTipoFichaSubListDB (tipoFichaSubList) {
    return postData('CvTipoFichaSubs/lista', UPDATE_TIPO_FICHA_SUB, tipoFichaSubList, 'Tipos de sub-ficha actualizados', undefined);

}

